import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { DisplayToast } from '@app/core/store/states/ui/ui-state.actions';
import { defaultToastError } from './default-toast-error.operator';

class SuccessDispatcher {
  @Dispatch()
  readonly successDispatch = (successMessage: string) =>
    new DisplayToast({
      type: 'success',
      title: successMessage,
    });
}

export function toastAction<T>(successMessage: string = 'common.success-msg', errorMessage?: string) {
  return (source: Observable<T>) =>
    source.pipe(
      tap(() => {
        if (!!successMessage) {
          new SuccessDispatcher().successDispatch(successMessage);
        }
      }),
      defaultToastError(errorMessage),
    );
}
